import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { routes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    // Routing principal
    provideRouter(routes),

    // Animaciones de Angular Material o ng-bootstrap
    provideAnimations(),

    // HttpClient con soporte para interceptores y fetch API
    provideHttpClient(withInterceptorsFromDi(), withFetch()),

    // Importación de módulos clásicos
    importProvidersFrom(NgbModule),

    // Service Worker (PWA)
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.SW,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
